import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  total: {},
  label: {},
});

const TabLabel = ({
  className,
  classes,
  label,
  total,
  TotalTypographyProps,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.total}
        color={'primary'}
        variant={'h2'}
        weight={'bold'}
        {...TotalTypographyProps}
      >
        {total}
      </Typography>
      <Typography
        className={classes.label}
      >
        {label}
      </Typography>
    </Box>
  );
};

TabLabel.defaultProps = {
  className: '',
  TotalTypographyProps: {},
};

TabLabel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  total: PropTypes.string.isRequired,
  TotalTypographyProps: PropTypes.object,
};

export default withStyles(styles)(TabLabel);
